module.exports = __webpack_public_path__ + "static/media/Print.e5c4524c.svg";